<template>
  <div class="case-creation__step case-creation__Case-information">
    <el-row>
      <el-col :span="24">
        <div class="case-creation__card">
          <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-case-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Case Information</h3>
            </div>
          </div>
          <div class="case-creation__body pb-0">
            <el-row :gutter="15">
              <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases" v-if="caseTypes.length">
                  <h4 class="name">Case Type</h4>
                  <ul
                    v-for="(caseType, index) of caseTypes"
                    :key="`case-type-${caseType}-${index}`"
                  >
                    <li>{{ caseTypeMap[caseType] }}</li>
                  </ul>
                </div>
              </el-col>
              <el-col
                :xl="3"
                :lg="4"
                :md="8"
                :sm="12"
                :xs="12"
                v-if="getCaseInformation && !showStatCase()"
              >
                <div class="input-value view-cases">
                  <h4 class="name">STAT Case</h4>
                  <p
                    class="value"
                    style="
                      background: #BF1B39;
                      width: 42px;
                      height: 18px;
                      border-radius: 10px;
                      padding-left: 14px;
                      color: white;
                    "
                    v-if="getCaseInformation?.is_stat"
                  >
                    Yes
                  </p>
                  <p class="value" v-else>--</p>
                </div>
              </el-col>
              <el-col :xl="2" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Order Date</h4>
                  <p class="value">{{ formattedOrderingDate }}</p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Ordering Facility</h4>
                  <p class="value">
                    {{ getCaseInformation?.hospital?.name || "--" }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Ordering Facility Branch</h4>
                  <p class="value">
                    {{
                      getCaseInformation?.hospital_branch?.display_name || "--"
                    }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Ordering Physician</h4>
                  <p class="value">
                    {{ getCaseInformation?.ordering_physician?.name || "--" }}
                  </p>
                </div>
              </el-col>

              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Referring Physician</h4>
                  <p class="value">
                    {{ getCaseInformation?.referring_physician?.name || "--" }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Bill To</h4>
                  <p class="value">{{ formattedBillingType }}</p>
                </div>
              </el-col>

              <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Order ID</h4>
                  <p class="value">
                    {{ getCaseInformation?.order_id || "--" }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Sample Collection Type</h4>
                  <p class="value">
                    {{ getCaseInformation?.sample_collection_type || "--" }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="13" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases icd-codes">
                  <div class="indicatives">
                    <h4 class="name">ICD-10 (Indicative)</h4>
                    <ul v-if="getCaseInformation?.icd_10_codes?.length">
                      <li
                        class="value"
                        v-for="(
                          icd_10_code, index
                        ) in getCaseInformation.icd_10_codes"
                        :key="`icd-${icd_10_code}-${index}`"
                      >
                        {{ icd_10_code }}
                      </li>
                    </ul>
                    <p class="value" v-else>--</p>
                  </div>
                </div>
              </el-col>
              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Collection Date</h4>
                  <p class="value">{{ formattedCollectionDate }}</p>
                </div>
              </el-col>

              <!-- <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Temperature</h4>
                  <p class="value">
                    {{ getCaseInformation?.temperature || "--" }}
                  </p>
                </div>
              </el-col> -->
              <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                <div class="input-value view-cases">
                  <h4 class="name">Order Notes</h4>
                  <p class="value">
                    {{ getCaseInformation?.order_notes?.join(", ") || "--" }}
                  </p>
                </div>
              </el-col>
              <el-col :xl="6" :lg="8" :md="12">
                <div class="input-value view-cases">
                  <div class="speciment-type-view" v-if="hasSampleTypes">
                    <div>
                      <h4 class="name">Specimen Types</h4>
                      <ul class="case_type" v-if="hasSampleTypes">
                        <li
                          class="value"
                          v-for="(
                            sampleType, index
                          ) in getCaseInformation.sample_types"
                          :key="`case-type-${sampleType.case_type}-${index}`"
                        >
                          <span>
                            {{ caseTypeMap[sampleType.case_type] }}
                          </span>
                        </li>
                      </ul>
                      <ul v-else>
                        --
                      </ul>
                    </div>
                    <div>
                      <h4 class="name">&nbsp;</h4>
                      <ul class="speciment_type" v-if="hasSampleTypes">
                        <li
                          v-for="(
                            sampleType, index
                          ) in getCaseInformation.sample_types"
                          :key="`sample-type-${index}`"
                        >
                          <span v-if="sampleType.sample_types?.length">
                            <span
                              v-for="(
                                sample, sampleIndex
                              ) in sampleType.sample_types"
                              :key="`sample-${sampleIndex}`"
                            >
                              {{ sample }}
                              <span
                                v-if="
                                  sampleIndex + 1 <
                                  sampleType.sample_types.length
                                "
                                >,</span
                              >
                            </span>
                          </span>
                          <span v-else>--</span>
                        </li>
                      </ul>
                      <ul v-else>
                        --
                      </ul>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xl="6" :lg="8" :md="12" v-if="getCaseInformation?.specimen_source">
                <div class="input-value view-cases">
                  <div class="speciment-type-view">
                    <div>
                      <h4 class="name">Specimen Location</h4>
                      <p class="value">{{ getCaseInformation?.specimen_source || "--"}}</p>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col
                :xl="3"
                :lg="4"
                :md="8"
                :sm="12"
                :xs="12"
                v-if="
                  getCaseInformation?.fasting
                "
              >
                <div class="input-value view-cases">
                  <h4 class="name">Fasting</h4>
                  <p class="value">
                    {{ getCaseInformation.fasting ? "Yes" : "No" }}
                  </p>
                </div>
              </el-col>
              <el-col
                :xl="6"
                :lg="8"
                :md="12"
                v-if="getCaseInformation?.sample_approval_data && getCaseInformation.sample_approval_data.length > 0"
              >
                <div class="input-value view-cases">
                  <h4 class="name">Previous Order Sample</h4>
                  <ul>
                    <li
                      v-for="(item, index) in getCaseInformation.sample_approval_data"
                      :key="index"
                      class="value"
                    >
                      Use Previous Order Sample: {{ item.order_id }}
                    </li>
                  </ul>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import GlobalHelper from "@/mixins/GlobalHelper";

export default {
  name: "CaseInformations",
  mixins: [UserPermissionsHelper, GlobalHelper],

  computed: {
    ...mapGetters("orders", ["getCaseInformation"]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    getPatientInformation() {
      return this.getCaseInformation?.patient_info || null;
    },
    hadClinicalChemistry() {
      return (
        this.getCaseInformation?.case_types?.includes("CLINICAL_CHEMISTRY") ||
        false
      );
    },
    // Pre-computed values to avoid repeated property access
    caseTypes() {
      return this.getCaseInformation?.case_types || [];
    },
    formattedOrderingDate() {
      const date =
        this.getCaseInformation?.order_placed_at ||
        this.getCaseInformation?.ordering_date;
      return date
        ? this.momentWithTimezoneTime(date, "MM-DD-yyyy")
        : "--";
    },
    formattedBillingType() {
      return this.getCaseInformation?.billing_type
        ? this.getCaseInformation.billing_type.split("_").join(" ")
        : "--";
    },
    formattedCollectionDate() {
      return this.getCaseInformation?.collection_date
        ? this.momentWithTimezoneTime(
            this.getCaseInformation.collection_date,
            "MM-DD-yyyy hh:mm A"
          )
        : "--";
    },
    hasSampleTypes() {
      return !!(
        this.getCaseInformation?.sample_types &&
        this.getCaseInformation.sample_types.length > 0
      );
    },
  },
  data() {
    return {
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.icd-codes {
  .indicatives {
    ul {
      display: flex;
      li {
        margin: 0 6px;
        p {
          .value {
            padding: 3px 12px !important;
          }
        }
      }
    }
  }
}
</style>
